import { render, staticRenderFns } from "./AddGoodOrServicePopup.vue?vue&type=template&id=1890dc68&scoped=true&"
import script from "./AddGoodOrServicePopup.vue?vue&type=script&lang=ts&"
export * from "./AddGoodOrServicePopup.vue?vue&type=script&lang=ts&"
import style0 from "./AddGoodOrServicePopup.vue?vue&type=style&index=0&id=1890dc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890dc68",
  null
  
)

export default component.exports